import { environment } from '../../environments/environment';

export class ApiUrl {
    static usePermit=Boolean(JSON.parse(environment.usePermit));
    private static version = this.usePermit ?'v3':'v2';
    public static readonly profiles = `${environment.apiUrl}/api/${ApiUrl.version}/Profiles`;
}